import StringUtils from '../../common/utils/StringUtils';

import AggregableDataModel from '../aggregable/AggregableDataModel';

const datacenterAssignmentKey = 'DatacenterAssignment';

export default class ForecastingDataModel extends AggregableDataModel {
  onFilterViewSchedule(contract, schedule) {
    const matchesDatacenter = this.currentDatacenterFilter === null
      || contract.parameters[datacenterAssignmentKey] === this.currentDatacenterFilter
      || StringUtils.isEmptyString(contract.parameters[datacenterAssignmentKey]);

    const matchesView = contract.parameters.ViewAssignment === this.currentFilter
      || StringUtils.isEmptyString(contract.parameters.ViewAssignment);

    return matchesDatacenter && matchesView;
  }
}